import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faClone, faEllipsisVertical, faFire} from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { useLocation } from 'react-router-dom';
import TradingViewWidget from "../components/TradingViewWidget";
import { formatLargeNumber } from '../utils/currencyUtils';

function Idetails() {
  const { user } = useUser();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const coinSymbol = params.get('symbol');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };

  const [newCrypto, setNewCrypto] = useState([]);
  const [cryptoDetails, setCryptoDetails] = useState([]);
  useEffect(() => {
      fetch(`/new_coin.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          coin_id: coin.id,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          circulating_supply: coin.circulating_supply,
          volume: coin.quote.USD.volume_24h,
          volume_24h: Number(coin.quote.USD.volume_change_24h.toFixed(2)),
          market_cap: coin.quote.USD.market_cap,
          platformLogo: coin.platform && coin.platform.id ? `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.platform.id}.png` : `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          platformName: coin.platform && coin.platform.name ? coin.platform.name : coin.name,
          platformSymbol: coin.platform && coin.platform.symbol ? coin.platform.symbol : coin.symbol,
          cmc_rank: coin.cmc_rank,
          date_added: coin.date_added,
          last_updated: coin.last_updated,
          max_supply: coin.max_supply ? coin.max_supply : 0,
          total_supply: coin.total_supply ? coin.total_supply : 0,
          percent_1h: Number(coin.quote.USD.percent_change_1h.toFixed(2)),
          percent_7d: Number(coin.quote.USD.percent_change_7d.toFixed(2)),
          percent_24h: Number(coin.quote.USD.percent_change_24h.toFixed(2)),
          percent_30d: Number(coin.quote.USD.percent_change_30d.toFixed(2)),
          percent_60d: Number(coin.quote.USD.percent_change_60d.toFixed(2)),
          percent_90d: Number(coin.quote.USD.percent_change_90d.toFixed(2)),
      }));
      setNewCrypto(updatedData);
      const foundCoin = updatedData.find(
        (coin) => coin.symbol.toLowerCase() === coinSymbol.toLowerCase()
      );
      if (foundCoin) {
        setCryptoDetails(foundCoin);
      }
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title={cryptoDetails.name} isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title={cryptoDetails.name} icon={<FontAwesomeIcon icon={faClone} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main className="mb-5">
            <div className="row">
                <div className="col-lg-8 col-xxl-9 d-none d-lg-block">
                    <div className="mycard p-2 mt-2">
                        <TradingViewWidget symbol={coinSymbol} type="crypto" />
                    </div>
                </div>
                <div className="col-lg-4 col-xxl-3">
                    <div className="mycard p-0 mt-2">
                        <div className="d-flex align-items-center justify-content-between p-2">
                            <div className="d-flex align-items-center">
                                <img src={cryptoDetails.logo} alt="image" className="me-2" style={{width:'30px',height:'30px'}}/>
                                <p className="fw-bold mb-0">{cryptoDetails.name}</p>
                            </div>
                            <div className="d-flex align-items-center justify-content-center overflow-hidden" style={{ width: "30px", height: "30px", border: '1px solid #ffffff34', borderRadius: '6px', cursor: 'pointer' }}>
                                <FontAwesomeIcon icon={faEllipsisVertical} style={{fontSize: '16px'}} />
                            </div>
                        </div>
                        <div className="bg-black d-flex flex-column align-items-center py-3">
                            <div className="d-flex align-items-center">
                                <p className="mb-0 fw-bold" style={{fontSize:'14px'}}>{cryptoDetails.symbol} / {cryptoDetails.platformSymbol}</p>
                                <p className="mb-0 text-prime fw-semibold ms-2" style={{fontSize:'14px'}}><FontAwesomeIcon icon={faFire} style={{fontSize: '12px'}} /> #1</p>
                            </div>
                            <div className="d-flex align-items-center">
                                <img src={cryptoDetails.platformLogo} alt="image" className="me-1" style={{width:'20px',height:'20px'}}/>
                                <p className="mb-0" style={{fontSize:'14px'}}>{cryptoDetails.platformSymbol}</p>
                                <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} className="mx-2"/>
                                <img src={cryptoDetails.logo} alt="image" className="me-1" style={{width:'20px',height:'20px'}}/>
                                <p className="mb-0" style={{fontSize:'14px'}}>{cryptoDetails.name}</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center overflow-hidden" style={{height:'120px'}}>
                            <img src="uploads/advert1.png" alt="image" className="me-1" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                        </div>
                        <div className="row mx-2 pb-2">
                            <div className="col-6 g-2">
                                <div className="rounded-3 p-2" style={{border:'1px solid #28282d'}}>
                                    <p className="mb-0 text-center text-secondary lh-1" style={{fontSize:'14px'}}>PRICE USD</p>
                                    <p className="mb-0 text-center fw-bold fs-5" style={{lineHeight:'110%'}}>${cryptoDetails.price}</p>
                                </div>
                            </div>
                            <div className="col-6 g-2">
                                <div className="rounded-3 p-2" style={{border:'1px solid #28282d'}}>
                                    <p className="mb-0 text-center text-secondary lh-1" style={{fontSize:'14px'}}>MKT CAP</p>
                                    <p className="mb-0 text-center fw-bold fs-5" style={{lineHeight:'110%'}}>{formatLargeNumber(cryptoDetails.market_cap)}</p>
                                </div>
                            </div>
                            <div className="col-4 g-2">
                                <div className="rounded-3 p-2" style={{border:'1px solid #28282d'}}>
                                    <p className="mb-0 text-center text-secondary lh-1" style={{fontSize:'14px'}}>VOLUME</p>
                                    <p className="mb-0 text-center fw-bold fs-5" style={{lineHeight:'110%'}}>{formatLargeNumber(cryptoDetails.volume)}</p>
                                </div>
                            </div>
                            <div className="col-4 g-2">
                                <div className="rounded-3 p-2" style={{border:'1px solid #28282d'}}>
                                    <p className="mb-0 text-center text-secondary lh-1" style={{fontSize:'14px'}}>VOLUME (%)</p>
                                    <p className={`mb-0 text-center fw-bold fs-5 ${cryptoDetails.volume_24h > 0 ?'text-success':'text-danger'}`} style={{lineHeight:'110%'}}>{cryptoDetails.volume_24h}%</p>
                                </div>
                            </div>
                            <div className="col-4 g-2">
                                <div className="rounded-3 p-2" style={{border:'1px solid #28282d'}}>
                                    <p className="mb-0 text-center text-secondary lh-1" style={{fontSize:'14px'}}>CIRC SUPPLY</p>
                                    <p className="mb-0 text-center fw-bold fs-5" style={{lineHeight:'110%'}}>{formatLargeNumber(cryptoDetails.circulating_supply)}</p>
                                </div>
                            </div>
                            <div className="col-3 g-2">
                                <div className="rounded-3 p-2" style={{border:'1px solid #28282d'}}>
                                    <p className="mb-0 text-center text-secondary lh-1" style={{fontSize:'14px'}}>1H</p>
                                    <p className={`mb-0 text-center fw-bold fs-5 ${cryptoDetails.percent_1h > 0 ?'text-success':'text-danger'}`} style={{lineHeight:'110%'}}>{cryptoDetails.percent_1h}%</p>
                                </div>
                            </div>
                            <div className="col-3 g-2">
                                <div className="rounded-3 p-2" style={{border:'1px solid #28282d'}}>
                                    <p className={`mb-0 text-center text-secondary lh-1 ${cryptoDetails.percent_24h > 0 ?'text-success':'text-danger'}`} style={{fontSize:'14px'}}>24H</p>
                                    <p className={`mb-0 text-center fw-bold fs-5 ${cryptoDetails.percent_24h > 0 ?'text-success':'text-danger'}`} style={{lineHeight:'110%'}}>{cryptoDetails.percent_24h}%</p>
                                </div>
                            </div>
                            <div className="col-3 g-2">
                                <div className="rounded-3 p-2" style={{border:'1px solid #28282d'}}>
                                    <p className="mb-0 text-center text-secondary lh-1" style={{fontSize:'14px'}}>7D</p>
                                    <p className={`mb-0 text-center fw-bold fs-5 ${cryptoDetails.percent_7d > 0 ?'text-success':'text-danger'}`} style={{lineHeight:'110%'}}>{cryptoDetails.percent_7d}%</p>
                                </div>
                            </div>
                            <div className="col-3 g-2">
                                <div className="rounded-3 p-2" style={{border:'1px solid #28282d'}}>
                                    <p className="mb-0 text-center text-secondary lh-1" style={{fontSize:'14px'}}>30D</p>
                                    <p className={`mb-0 text-center fw-bold fs-5 ${cryptoDetails.percent_30d > 0 ?'text-success':'text-danger'}`} style={{lineHeight:'110%'}}>{cryptoDetails.percent_30d}%</p>
                                </div>
                            </div>
                            <div className="col-3 g-2">
                                <div className="rounded-3 p-2" style={{border:'1px solid #28282d'}}>
                                    <p className="mb-0 text-center text-secondary lh-1" style={{fontSize:'14px'}}>60D</p>
                                    <p className={`mb-0 text-center fw-bold fs-5 ${cryptoDetails.percent_60d > 0 ?'text-success':'text-danger'}`} style={{lineHeight:'110%'}}>{cryptoDetails.percent_60d}%</p>
                                </div>
                            </div>
                            <div className="col-3 g-2">
                                <div className="rounded-3 p-2" style={{border:'1px solid #28282d'}}>
                                    <p className="mb-0 text-center text-secondary lh-1" style={{fontSize:'14px'}}>90D</p>
                                    <p className={`mb-0 text-center fw-bold fs-5 ${cryptoDetails.percent_90d > 0 ?'text-success':'text-danger'}`} style={{lineHeight:'110%'}}>{cryptoDetails.percent_90d}%</p>
                                </div>
                            </div>
                            <div className="col-6 g-2">
                                <div className="rounded-3 p-2 mycard d-flex justify-content-center">
                                    <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>#{cryptoDetails.cmc_rank}</p>
                                </div>
                            </div>
                            <div className="col-6 g-2">
                                <div className="rounded-3 p-2 mycard d-flex justify-content-center">
                                    <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Alerts</p>
                                </div>
                            </div>
                            <div className="col-12 g-2">
                                <div className="rounded-3 p-2 mycard d-flex justify-content-center">
                                    <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Watchlist</p>
                                </div>
                            </div>
                            <div className="col-12 g-2">
                                <div className="rounded-3 p-2 mycard">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Date Added</p>
                                        <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{cryptoDetails.date_added}</p>
                                    </div>
                                    <hr className="my-2"/>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Last Update</p>
                                        <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{cryptoDetails.last_updated}</p>
                                    </div>
                                    <hr className="my-2"/>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Maximum Supply</p>
                                        <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{formatLargeNumber(cryptoDetails.max_supply)}</p>
                                    </div>
                                    <hr className="my-2"/>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Total Supply</p>
                                        <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{formatLargeNumber(cryptoDetails.total_supply)}</p>
                                    </div>
                                    <hr className="my-2"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Idetails